<template>

	<span>

		<span :style="accentStyle">
			<slot></slot>
		</span>

	</span>

</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

import EventBus from "../../EventBus";

export default defineComponent({
	name: "Accent",

	setup() {

		const accentStyle = computed(() =>
		{
			return {
				color: EventBus.accentColor,
				fontWeight: EventBus.accentBold ? "bold" : "normal"
			};
		});

		return {
			accentStyle
		};
	}
});
</script>